import { Controller } from "@hotwired/stimulus"

// Toggles a quote row between a read-only display and its edit form.
//
// Saved rows render in display mode with an Edit button; clicking Edit reveals
// the form. Saving submits the form (Turbo re-renders the section back to
// display mode). A freshly added row starts in edit mode via the `editing` value
// and is not persisted yet: Cancel removes it instead of revealing an empty line.
export default class extends Controller {
  static targets = ["display", "edit"]
  static values = {
    editing: { type: Boolean, default: false },
    persisted: { type: Boolean, default: true }
  }

  connect() {
    this.render()
    if (!this.persistedValue && this.editingValue) this.reveal()
  }

  edit(event) {
    if (event) event.preventDefault()
    this.editingValue = true
    this.render()
    // Focus the first field so the user can start editing immediately.
    this.editTarget.querySelector("select, input, textarea")?.focus()
  }

  cancel(event) {
    if (event) event.preventDefault()
    if (!this.persistedValue) {
      this.removeUnsavedRow()
      return
    }

    this.editingValue = false
    this.render()
  }

  // A new line is appended under the table. Smooth scrollIntoView no-ops in
  // this theme, so move the window ourselves once the row has laid out.
  reveal() {
    const target = this.hasEditTarget ? this.editTarget : this.element
    requestAnimationFrame(() => {
      const margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 80
      const top = target.getBoundingClientRect().top + window.scrollY - margin
      window.scrollTo({ top })
      target.querySelector("select, input, textarea")?.focus()
    })
  }

  removeUnsavedRow() {
    const row = this.element.closest(".border-bottom")
    const group = row?.closest("[data-sales-quote-group]")
    row?.remove()
    if (group && !group.querySelector("[data-controller='row-edit']")) group.remove()
  }

  render() {
    if (this.hasDisplayTarget) this.displayTarget.classList.toggle("d-none", this.editingValue)
    if (this.hasEditTarget) this.editTarget.classList.toggle("d-none", !this.editingValue)
  }
}
